'use client';

import type { ConsentCategory } from '../types';

type DataObject = {
  tealium_event?: string | string[];
  country_code?: string | string[];
  currency_code?: string | string[];
  page_name?: string | string[];
  page_type?: string | string[];
  product_id?: string | string[];
  product_name?: string | string[];
  product_category?: string | string[];
  product_quantity?: string | string[];
  product_unit_price?: string | string[];
  cart_total_items?: string | string[];
  cart_subtotal?: string | string[];
  search_results?: string | string[];
  search_keyword?: string | string[];
  [key: string]: undefined | string | string[];
};

// Expand the definition by inspecting the Tealium API:
// https://docs.tealium.com/platforms/javascript/api/
// Unfortunately, there is no preexisting typescript type.
export type Utag = {
  gdpr: {
    getCategories: (onlyEnabledCategories?: boolean) => ConsentCategory[];
    getSelectedCategories: () => ConsentCategory[];
    showConsentPreferences: (languageCodeWithRegion?: string) => void;
    setAllCategories: (state: boolean, noCollect?: boolean) => void;
    setPreferencesFromList: (list: ConsentCategory[]) => void;
    setPreferencesValues: (
      state: Record<ConsentCategory, '0' | '1'>,
      noCollect?: boolean,
    ) => void;
  };
  link: (data: DataObject, callback?: () => void, uidArray?: string[]) => void;
  track: (data: DataObject, callback?: () => void, uidArray?: string[]) => void;
  view: (data: DataObject, callback?: () => void, uidArray?: string[]) => void;
};

type WindowWithTealium = Window & {
  utag_cfg_ovrd?: {
    noview?: boolean;
  };
  utag?: Utag;
};

export const getUtag = (
  window: undefined | Window | WindowWithTealium,
): Utag | undefined => {
  if (window && 'utag' in window && window.utag) {
    return window.utag;
  }

  return undefined;
};
